import { createFetcher } from '../contexts/Fetcher';
import { useCallback } from 'react';
import { AnalyticsActivityType, apiActivity } from '../resources/api/apiActivity';

const { useGetActivity } = apiActivity;

export const ActivityFetcher = createFetcher(() => {
  const { execute } = useGetActivity();

  return useCallback(
    ({ type }: { type: AnalyticsActivityType }) => {
      return execute(type);
    },
    [execute]
  );
});
